import { mapGetters, mapMutations, mapActions } from "vuex";
import moment from "../../../plugins/moment";
import isMobileMixin from "../../../utils/mixins/isMobile";
import { ucfirst } from '../../../utils/strings';
import * as DESTINIES_GETTERS from "../../../store/destinies/getter-types";
import * as SEARCH_GETTERS from "../../../store/search/getter-types";
import * as SEARCH_MUTATION from "../../../store/search/mutation-types";
import * as SEARCH_ACTIONS from "../../../store/search/action-types";
import { daysOfTheWeek } from '../../../utils/trans';

export default {
  mixins: [isMobileMixin],
  data: () => ({
    personsOptions: ["1 persona", "2 personas", "3 personas"],
    daysOfWeek: [...daysOfTheWeek[window.appLocale].slice(-1), ...daysOfTheWeek[window.appLocale].slice(0, -1)],
    form: {
      loading: false,
      valid: false,
      showErrors: false,
      showTravellersMenu: false,
      date: {
        showMenu: false,
        value: null
      },
      moredaysDate:{
        showMenu: false,
        value: []
      }
    }
  }),
  computed: {
    ...mapGetters({
      searchValues: SEARCH_GETTERS.GET_SEARCH,
      originsOptions: DESTINIES_GETTERS.GET_ORIGINS_OPTIONS,
      destiniesOptions: DESTINIES_GETTERS.GET_DESTINIES_OPTIONS
    }),
    origin: {
      get() {
        return this.searchValues.origin;
      },
      set(value) {
        this.handleSelectLocation(value);
      }
    },
    sortedDestiniesOptions() {
      return this.destiniesOptions.sort((a, b) => a.minPrice - b.minPrice);
    },
    travellers() {
      return this.searchValues.travellers;
    },
    travellersLabel() {
      const total =
        this.travellers.adults +
        this.travellers.childs +
        this.travellers.babies;

      if (total > 0) {
        return total + " " + this.$tc('shared.person', total);
      } else {
        return this.$t('choose_people');
      }
    },
    parsedDate() {
      const date = this.searchValues.date;
      if (date) {
        if (date.isValid()) {
          return date.format("DD/MM/YYYY");
        } else {
          this.setSearchDate(null);
          this.$toastr.e(
            window.i18n.t('toast.error_9')
          );
        }
      }
      return "DD/MM/YYYY";
    },
    moredaysDateText(){
      const [dateStart, dateEnd] = this.form.moredaysDate.value;
      if (! dateStart || ! dateEnd) {
        return "DD/MM/YYYY";
      }
      const momentStart = moment(dateStart);
      const momentEnd = moment(dateEnd);
      return moment(dateStart).format("DD/MM/YY") + ' - ' + moment(dateEnd).format("DD/MM/YY");
    },
    moreDaysStartText(){
      const dateStart = this.form.moredaysDate.value[0];
      if(!dateStart){
        return this.$t('shared.outbound_trip');
      }
      return moment(dateStart).format("DD/MM/YY");
    },
    moreDaysEndText(){
      const dateEnd = this.form.moredaysDate.value[1];
      if(!dateEnd){
        return ucfirst(this.$t('shared.inbound_trip'));
      }
      return moment(dateEnd).format("DD/MM/YY");
    },
    destiny: {
      get() {
        return this.searchValues.destiny;
      },
      set(value) {
        this.handleSelectLocation(
          value,
          "destiniesOptions",
          "setSearchDestiny"
        );
      }
    },
    isMobileMixin() {
      return this.isMobile();
    }
  },
  methods: {
    ...mapMutations({
      setSearchOrigin: SEARCH_MUTATION.SET_SEARCH_ORIGIN,
      setSearchDestiny: SEARCH_MUTATION.SET_SEARCH_DESTINY,
      setSearchDate: SEARCH_MUTATION.SET_SEARCH_DATE,
      setSearchMoreStart: SEARCH_MUTATION.SET_SEARCH_MORE_START_DATE,
      setSearchMoreEnd: SEARCH_MUTATION.SET_SEARCH_MORE_END_DATE,
    }),
    ...mapActions({
      searchWhen: SEARCH_ACTIONS.SEARCH_WHEN,
      searchWhere: SEARCH_ACTIONS.SEARCH_WHERE,
      searchMoreDays: SEARCH_ACTIONS.SEARCH_MORE_DAYS,
      setTravellers: SEARCH_ACTIONS.SET_TRAVELLERS
    }),
    handleSelectLocation(
      code,
      getter = "originsOptions",
      mutation = "setSearchOrigin"
    ) {
      const location = this[getter].find(location => {
        return location.code === code;
      });
      if (location) {
        this[mutation](location);
      } else {
        this.$toastr.e(
          window.i18n.t('toast.error_3')
        );
      }
    },
    handleTravellersUpdate(event) {
      const travellers = {
        adults: this.travellers.adults,
        childs: this.travellers.childs,
        babies: this.travellers.babies
      };
    
      if (this.cityDestinationCode === 'RAK' && event.id === 'adults' && event.value < 2) {
        travellers.adults = 2; 
        this.showMinimumPassengerMessage = true;
      } else {
        travellers[event.id] = event.value;
        this.showMinimumPassengerMessage = false;
      }
  
    
      this.setTravellers(travellers).catch(err => {
        this.$toastr.e(
          window.i18n.t('toast.error_6')
        );
      });
    },
    handleSelectDate(value) {
      const date = moment(value, "YYYY-MM-DD");
      this.setSearchDate(date);
      this.form.date.showMenu = false;
    },
    handleSelectMoreDate(value) {
      const date1 = moment(value[0], "YYYY-MM-DD");
      const date2 = moment(value[1], "YYYY-MM-DD");
      if (date1.isSame(date2)) {
        this.form.moredaysDate.value = [];
        return;
      }
      if (date1.isBefore(date2)) {
        this.setSearchMoreStart(date1);
        this.setSearchMoreEnd(date2);
      } else {
        this.form.moredaysDate.value = [value[1], value[0]];
        this.setSearchMoreStart(date2);
        this.setSearchMoreEnd(date1);
      }
    },
    getDay(date) {
      let i = new Date(date).getDay();
      return this.daysOfWeek[i];
    },
    search(searchType = 0) {
      this.form.showErrors = false;
      if (
        this.searchValues.origin &&
        (
          ([0, 1].includes(this.searchType) && (this.searchValues.destiny || this.searchValues.date)) ||
          (this.searchType === 2 &&
            this.searchValues.dateRange.start && this.searchValues.dateRange.start._isValid &&
            this.searchValues.dateRange.end && this.searchValues.dateRange.end._isValid)
        )
      ) {
        this.form.loading = true;
        setTimeout(() => {
          switch (searchType) {
            case 0:
              this.searchWhen()
                .finally(() => {
                  this.form.loading = false;
                })
                .catch(() => {
                  this.$toastr.e(
                    window.i18n.t('toast.error_3')
                  );
                });
              break;
            case 1:
              this.searchWhere()
                .finally(() => {
                  this.form.loading = false;
                })
                .catch(() => {
                  this.$toastr.e(
                    window.i18n.t('toast.error_3')
                  );
                });
              break;
            case 2:
              this.searchMoreDays()
                .finally(() => {
                  this.form.loading = false;
                })
                .catch(() => {
                  this.$toastr.e(
                    window.i18n.t('toast.error_3')
                  );
                });
              break;
            default:
              break;
          }
        }, 400);
      } else {
        this.form.showErrors = true;
      }
    }
  },
  mounted() {
    if (this.cityDestinationCode === 'RAK' && this.travellers.adults < 2) {
      this.setTravellers({
        ...this.travellers,
        adults: 2
      }).catch(err => {
        this.$toastr.e(
          window.i18n.t('toast.error_6')
        );
      });
    }
  }
  };
